import React from 'react';

/* ── Shared parts ── */
const Body = () => (
  <>
    {/* Body */}
    <ellipse cx="100" cy="210" rx="68" ry="72" fill="#EF5350" stroke="#111" strokeWidth="5"/>
    {/* Belly patch */}
    <ellipse cx="100" cy="218" rx="38" ry="42" fill="#FFCDD2"/>
    {/* Left leg */}
    <ellipse cx="68"  cy="274" rx="20" ry="14" fill="#EF5350" stroke="#111" strokeWidth="4"/>
    {/* Right leg */}
    <ellipse cx="132" cy="274" rx="20" ry="14" fill="#EF5350" stroke="#111" strokeWidth="4"/>
  </>
);

const Head = () => (
  <>
    {/* Head */}
    <circle cx="100" cy="118" r="62" fill="#EF5350" stroke="#111" strokeWidth="5"/>
    {/* Cheeks */}
    <ellipse cx="64"  cy="130" rx="14" ry="10" fill="#EF9A9A" opacity="0.7"/>
    <ellipse cx="136" cy="130" rx="14" ry="10" fill="#EF9A9A" opacity="0.7"/>
    {/* Nose */}
    <ellipse cx="100" cy="126" rx="9" ry="6" fill="#F48FB1" stroke="#111" strokeWidth="2"/>
  </>
);

/* ── Long floppy ears ── */
const Ears = () => (
  <>
    <ellipse cx="68"  cy="52" rx="22" ry="44" fill="#EF5350" stroke="#111" strokeWidth="5"/>
    <ellipse cx="68"  cy="52" rx="12" ry="32" fill="#F48FB1"/>
    <ellipse cx="132" cy="52" rx="22" ry="44" fill="#EF5350" stroke="#111" strokeWidth="5"/>
    <ellipse cx="132" cy="52" rx="12" ry="32" fill="#F48FB1"/>
  </>
);

/* ── Crying face eyes ── */
const CryingEyes = () => (
  <>
    {/* Squinted crying eyes (X shape) */}
    <line x1="80"  y1="104" x2="92"  y2="116" stroke="#111" strokeWidth="5" strokeLinecap="round"/>
    <line x1="92"  y1="104" x2="80"  y2="116" stroke="#111" strokeWidth="5" strokeLinecap="round"/>
    <line x1="108" y1="104" x2="120" y2="116" stroke="#111" strokeWidth="5" strokeLinecap="round"/>
    <line x1="120" y1="104" x2="108" y2="116" stroke="#111" strokeWidth="5" strokeLinecap="round"/>
    {/* Tears */}
    <ellipse cx="84"  cy="122" rx="5" ry="8" fill="#90CAF9" style={{animation:'tear-fall 0.8s linear infinite'}}/>
    <ellipse cx="116" cy="122" rx="5" ry="8" fill="#90CAF9" style={{animation:'tear-fall 0.8s linear infinite 0.4s'}}/>
    {/* Mouth – sad */}
    <path d="M82 144 Q100 134 118 144" fill="none" stroke="#111" strokeWidth="4" strokeLinecap="round"/>
  </>
);

/* ── Happy face eyes ── */
const HappyEyes = () => (
  <>
    {/* Arc eyes */}
    <path d="M78 110 Q86 100 94 110" fill="none" stroke="#111" strokeWidth="5" strokeLinecap="round"/>
    <path d="M106 110 Q114 100 122 110" fill="none" stroke="#111" strokeWidth="5" strokeLinecap="round"/>
    {/* Big smile */}
    <path d="M78 136 Q100 158 122 136" fill="none" stroke="#111" strokeWidth="5" strokeLinecap="round"/>
  </>
);

/* ── Arms ── */
const ArmsCrying = () => (
  <>
    <ellipse cx="32"  cy="192" rx="16" ry="26" fill="#EF5350" stroke="#111" strokeWidth="4" transform="rotate(15 32 192)"/>
    <ellipse cx="168" cy="192" rx="16" ry="26" fill="#EF5350" stroke="#111" strokeWidth="4" transform="rotate(-15 168 192)"/>
  </>
);

/* Arms raised / open holding toy */
const ArmsHappy = () => (
  <>
    <ellipse cx="26"  cy="176" rx="16" ry="26" fill="#EF5350" stroke="#111" strokeWidth="4" transform="rotate(35 26 176)"/>
    <ellipse cx="174" cy="176" rx="16" ry="26" fill="#EF5350" stroke="#111" strokeWidth="4" transform="rotate(-35 174 176)"/>
  </>
);

/* ── Dance arms (waving) ── */
const ArmsDance = ({ tick }) => {
  const angle = tick % 2 === 0 ? 50 : -20;
  return (
    <>
      <ellipse cx="26"  cy="180" rx="16" ry="26" fill="#EF5350" stroke="#111" strokeWidth="4"
        transform={`rotate(${angle} 26 180)`}
        style={{transition:'transform 0.35s ease-in-out'}}/>
      <ellipse cx="174" cy="180" rx="16" ry="26" fill="#EF5350" stroke="#111" strokeWidth="4"
        transform={`rotate(${-angle} 174 180)`}
        style={{transition:'transform 0.35s ease-in-out'}}/>
    </>
  );
};

/* ── Tail ── */
const Tail = () => (
  <circle cx="162" cy="230" r="16" fill="white" stroke="#111" strokeWidth="3.5"/>
);

/* ── Sparkles around Max when happy ── */
export function Sparkles() {
  const positions = [
    {x:'8%',  y:'22%'},
    {x:'82%', y:'18%'},
    {x:'6%',  y:'62%'},
    {x:'84%', y:'58%'},
    {x:'46%', y:'8%'},
  ];
  return (
    <>
      {positions.map((p, i) => (
        <div key={i} style={{
          position:'absolute', left:p.x, top:p.y,
          fontSize: i % 2 === 0 ? '28px' : '22px',
          animation:`sparkle-burst 0.7s ease-out ${i * 0.1}s both`,
          pointerEvents:'none',
        }}>⭐</div>
      ))}
    </>
  );
}

/* ── Main component ── */
export default function MaxCharacter({ state = 'crying', danceTick = 0 }) {
  const isCrying     = state === 'crying';
  const isHappy      = state === 'happy';
  const isDancing    = state === 'dancing';

  const wrapperAnim =
    isCrying  ? 'anim-cry-shake' :
    isHappy   ? 'anim-happy-pop' :
    isDancing ? 'anim-dance'     : '';

  return (
    <div style={{position:'relative', width:'200px', height:'290px', flexShrink:0}}>
      <svg
        viewBox="0 0 200 290"
        xmlns="http://www.w3.org/2000/svg"
        className={wrapperAnim}
        style={{width:'100%', height:'100%', overflow:'visible'}}
      >
        <Ears/>
        <Tail/>
        <Body/>
        {isDancing ? <ArmsDance tick={danceTick}/> : isHappy ? <ArmsHappy/> : <ArmsCrying/>}
        <Head/>
        {isCrying ? <CryingEyes/> : <HappyEyes/>}
      </svg>
    </div>
  );
}
